import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/es";
import localeData from "dayjs/plugin/localeData";
import {
  IonCard,
  IonCardContent,
  IonCol,
  IonGrid,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonRow,
} from "@ionic/react";

import { callSharp, logoWhatsapp } from "ionicons/icons";
import CustomDesplegable from "../../components/basicsComponents/CustomDesplegable/CustomDesplegable";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import { DialogoConfirmacion } from "../../components/basicsComponents/DialogoConfirmacion/DialogoConfirmacion";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import {
  borrarObjetosDuplicados,
  ordenarArrayObjetosByDate,
} from "../../utils/funcionalidadesArrays";
import {
  HoraDentrodelLimite,
  obtenerNombreDia,
  parseHorario,
} from "../../utils/funcionalidadesStrings";
import { obtenerNotaWebMutual } from "../../utils/mutuales";
import {
  Column,
  Container,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import CustomCalendar from "../../components/basicsComponents/Calendar";
import { Typography } from "@mui/joy";
import useTituloPagina from "../../hooks/tituloPagina";
import "./NuevoTurno.css";
var weekOfYear = require("dayjs/plugin/weekOfYear");

dayjs.extend(weekOfYear);
dayjs.locale("es");
dayjs.extend(localeData);

const camposVirtualesPrestador = [
  "domMEsVirtual",
  "domTEsVirtual",
  "lunMEsVirtual",
  "lunTEsVirtual",
  "marMEsVirtual",
  "marTEsVirtual",
  "mieMEsVirtual",
  "mieTEsVirtual",
  "jueMEsVirtual",
  "jueTEsVirtual",
  "vieMEsVirtual",
  "vieTEsVirtual",
  "sabMEsVirtual",
  "sabTEsVirtual",
];

const camposPresencialesPrestador = [
  "domPresencialM",
  "domPresencialT",
  "lunPresencialM",
  "lunPresencialT",
  "marPresencialM",
  "marPresencialT",
  "miePresencialM",
  "miePresencialT",
  "juePresencialM",
  "juePresencialT",
  "viePresencialM",
  "viePresencialT",
  "sabPresencialM",
  "sabPresencialT",
];

const camposWebPrestador = [
  "domWebM",
  "domWebT",
  "lunWebM",
  "lunWebT",
  "marWebM",
  "marWebT",
  "mieWebM",
  "mieWebT",
  "jueWebM",
  "jueWebT",
  "vieWebM",
  "vieWebT",
  "sabWebM",
  "sabWebT",
];

const prestadorTieneModalidadDisponible = (
  horariosPrestador,
  modalidadSeleccionada,
) => {
  if (modalidadSeleccionada === null) {
    return true;
  }

  if (!horariosPrestador || horariosPrestador.length === 0) {
    return false;
  }

  const camposModalidad =
    modalidadSeleccionada === "virtual"
      ? camposVirtualesPrestador
      : camposPresencialesPrestador;

  return horariosPrestador.some((horarioPrestador) =>
    camposModalidad.some(
      (campo) =>
        Number(obtenerValorCampoHorario(horarioPrestador, campo) || 0) > 0,
    ),
  );
};

const obtenerLabelModalidad = (modalidadSeleccionada) =>
  modalidadSeleccionada === "virtual" ? "Virtual" : "Presencial";

const obtenerDescripcionModalidadTurno = (esVirtual) =>
  esVirtual ? "Atención Virtual" : "Atención Presencial";

const obtenerCampo = (objeto, ...campos) => {
  const campoEncontrado = campos.find(
    (campo) => objeto?.[campo] !== undefined && objeto?.[campo] !== null,
  );

  return campoEncontrado ? objeto[campoEncontrado] : undefined;
};

const normalizarCodigo = (valor) => Number(valor);

const inferirMimeTypeImagenBase64 = (imagenBase64 = "") => {
  if (typeof imagenBase64 !== "string") {
    return "image/jpeg";
  }

  const imagenNormalizada = imagenBase64.trim();

  if (imagenNormalizada.startsWith("/9j/")) {
    return "image/jpeg";
  }

  if (imagenNormalizada.startsWith("iVBORw0KGgo")) {
    return "image/png";
  }

  if (imagenNormalizada.startsWith("Qk")) {
    return "image/bmp";
  }

  if (imagenNormalizada.startsWith("UklGR")) {
    return "image/webp";
  }

  return "image/jpeg";
};

const obtenerFotoPrestador = (prestador = {}) => {
  const foto = obtenerCampo(
    prestador,
    "foto",
    "Foto",
    "fotoWeb",
    "FotoWeb",
    "imagen",
    "Imagen",
    "imagenWeb",
    "ImagenWeb",
    "fotoBase64",
    "FotoBase64",
    "imagenBase64",
    "ImagenBase64",
  );

  if (typeof foto !== "string" || foto.trim() === "") {
    return "";
  }

  const fotoNormalizada = foto.trim();
  if (
    fotoNormalizada.startsWith("data:") ||
    fotoNormalizada.startsWith("http://") ||
    fotoNormalizada.startsWith("https://")
  ) {
    return fotoNormalizada;
  }

  const mimeType = inferirMimeTypeImagenBase64(fotoNormalizada);
  return `data:${mimeType};base64,${fotoNormalizada}`;
};

const obtenerValorCampoHorario = (horarioPrestador, campo) => {
  if (!horarioPrestador) {
    return 0;
  }

  const variantesCampo = [
    campo,
    `${campo.charAt(0).toUpperCase()}${campo.slice(1)}`,
  ];

  const claveEncontrada = variantesCampo.find(
    (clave) =>
      horarioPrestador?.[clave] !== undefined &&
      horarioPrestador?.[clave] !== null,
  );

  return claveEncontrada ? horarioPrestador[claveEncontrada] : 0;
};

const tieneTurnoVisiblePorModalidad = (turno, modalidadSeleccionada) => {
  const turnoNormalizado = normalizarModalidadesTurno(turno);
  const esVirtualVisible = turnoNormalizado.permiteVirtual;
  const esPresencialVisible =
    turnoNormalizado.permitePresencial && !turnoNormalizado.entreTurno;

  if (
    !turnoNormalizado.libre ||
    turnoNormalizado.cancelado ||
    turnoNormalizado.reservado
  ) {
    return false;
  }

  return modalidadSeleccionada === "virtual"
    ? esVirtualVisible
    : esPresencialVisible;
};

const obtenerVarianteDiaAgenda = (cantTurnosPresencial, cantTurnosVirtual) => {
  if (cantTurnosPresencial > 0 && cantTurnosVirtual > 0) {
    return "mixto";
  }

  if (cantTurnosVirtual > 0) {
    return "virtual";
  }

  return "presencial";
};

const esCampoVerdadero = (valor) =>
  valor === true ||
  valor === 1 ||
  valor === "1" ||
  (typeof valor === "string" && valor.toLowerCase() === "true");

const prestadorTieneFranjaWeb = (horariosPrestador) =>
  horariosPrestador.some((horarioPrestador) =>
    camposWebPrestador.some((campo) =>
      esCampoVerdadero(obtenerValorCampoHorario(horarioPrestador, campo)),
    ),
  );

const normalizarModalidadesTurno = (turno) => {
  const telemedicina = esCampoVerdadero(turno.telemedicina);
  const presencial = esCampoVerdadero(turno.presencial);
  const permiteVirtual = telemedicina;
  const permitePresencial = presencial || !telemedicina;

  return {
    ...turno,
    permiteVirtual,
    permitePresencial,
    modalidadTurno:
      permiteVirtual && permitePresencial
        ? "mixto"
        : permiteVirtual
          ? "virtual"
          : "presencial",
  };
};

const prestadorTieneAgendaModalidad = async (
  url,
  config,
  prestadorCodigo,
  modalidadSeleccionada,
) => {
  try {
    const response = await axios.get(
      `${url}Turnos/TurnosPrestadorFecha/?prestador=${prestadorCodigo}&desde=${dayjs().format(
        "YYYY/MM/DD HH:mm",
      )}&hasta=${dayjs().add(3, "month").format("YYYY/MM/DD HH:mm")}`,
      config,
    );

    const turnosPrestador = Array.isArray(response.data) ? response.data : [];
    return turnosPrestador.some((turno) =>
      tieneTurnoVisiblePorModalidad(turno, modalidadSeleccionada),
    );
  } catch (error) {
    return false;
  }
};

export default function NuevoTurno() {
  const diasSemana = [
    "domingo",
    "lunes",
    "martes",
    "miercoles",
    "jueves",
    "viernes",
    "sabado",
  ];
  const [usuario, setUsuario] = useState({});
  const [cargando, setCargando] = useState(false);
  const [urlAxioPP, setUrlAxio] = useState("");
  const [tituloPagina, setTituloPagina] = useState("");
  const [modalidadSeleccionada, setModalidadSeleccionada] = useState(null);
  const [especialidades, setEspecialidades] = useState([]);
  const [horariosPrestadores, setHorariosPrestadores] = useState([]);
  const [horariosPrestadoresCargados, setHorariosPrestadoresCargados] =
    useState(false);
  const [prestadores, setPrestadores] = useState([]);
  const [listadoPrestadores, setListadoPrestadores] = useState([]);
  const [especialidadSeleccionada, setEspecialidadSeleccionada] = useState(-1);
  const [prestadorSeleccionado, setPrestadorSeleccionado] = useState(-1);
  const [
    prestadorSeleccionadoExternamente,
    setPrestadorSeleccionadoExternamente,
  ] = useState(false);
  const [prestadorPreseleccionado, setPrestadorPreseleccionado] =
    useState(null);
  const [fechasFuturas, setFechasFuturas] = useState([]);
  const [fechaSeleccionada, setFechaSeleccionada] = useState("");
  const [turnosPaciente, setTurnosPaciente] = useState([]);
  const [turnosDisponibles, setTurnosDisponibles] = useState([]);
  const [turnoSeleccionado, setTurnoSeleccionado] = useState({});
  const [mostrarInasisEspecilidad, setMostrarInasisEspecilidad] =
    useState(false);
  const [mostrarTurnoPrestadorReservado, setMostrarTurnoPrestadorReservado] =
    useState(false);
  const [abrirDesplegableEspecialidades, setAbrirDesplegableEspecialidades] =
    useState(false);
  const [abrirDesplegablePrestadores, setAbrirDesplegablePrestadores] =
    useState(false);

  const [abrirModalConfirmarReserva, setAbrirModalConfirmarReserva] =
    useState(false);
  const [abrirModalSelectorModalidad, setAbrirModalSelectorModalidad] =
    useState(false);
  const [abrirModalPostReserva, setAbrirModalPostReserva] = useState(false);
  const [notaWebMutual, setNotaWebMutual] = useState("");
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const cargaDesplegablesRef = useRef(0);

  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const history = useHistory();

  useTituloPagina();

  const mostrarNotaWebMutual =
    especialidadSeleccionada !== -1 &&
    prestadorSeleccionado !== -1 &&
    notaWebMutual !== "" &&
    !mostrarInasisEspecilidad &&
    !mostrarTurnoPrestadorReservado;
  const prestadorActual = prestadores.find(
    (prestador) => Number(prestador.codigo) === Number(prestadorSeleccionado),
  );
  const mostrarTurnosWhatsapp =
    prestadorActual?.sinFranjasWeb &&
    !mostrarInasisEspecilidad &&
    !mostrarTurnoPrestadorReservado;

  const obtenerNombreEspecialidadPrestador = (prestador = {}) => {
    const especialidadCodigo =
      prestador.especialidad ||
      prestador.especialidad2 ||
      prestador.especialidad3;
    const especialidad = especialidades.find(
      (item) => Number(item.codigo) === Number(especialidadCodigo),
    );

    return especialidad?.nombre || prestador.especialidadNom || "";
  };

  const limpiarEstadoReserva = ({ limpiarCatalogos = false } = {}) => {
    if (limpiarCatalogos) {
      setEspecialidades([]);
      setPrestadores([]);
      setListadoPrestadores([]);
    }

    setEspecialidadSeleccionada(-1);
    setPrestadorSeleccionado(-1);
    setFechasFuturas([]);
    setFechaSeleccionada("");
    setTurnosDisponibles([]);
    setTurnoSeleccionado({});
    setMostrarInasisEspecilidad(false);
    setMostrarTurnoPrestadorReservado(false);
    setAbrirDesplegableEspecialidades(false);
    setAbrirDesplegablePrestadores(false);
  };

  const iniciarCargaDesplegables = () => {
    const requestId = cargaDesplegablesRef.current + 1;
    cargaDesplegablesRef.current = requestId;
    setCargando(true);
    return requestId;
  };

  const esCargaDesplegablesVigente = (requestId) =>
    cargaDesplegablesRef.current === requestId;

  const finalizarCargaDesplegables = (requestId) => {
    if (esCargaDesplegablesVigente(requestId)) {
      setCargando(false);
    }
  };

  const obtenerPrimerosProximosTurnos = async (
    paciente,
    prestadores,
    horariosPrestadoresDisponibles,
  ) => {
    let turnos = [];
    let prestadoresFormateados = [];
    let turnosDisponibles = [];
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };
    const url = localStorage.getItem("urlAxioPP");

    try {
      const response = await axios.get(
        `${url}Turnos/TurnosPrestadorFechaXDia/?mutual=${
          paciente.mutual
        }&desde=${dayjs()
          .add(1, "day")
          .format("YYYY/MM/DD HH:mm")}&hasta=${dayjs()
          .add(4, "month")
          .format("YYYY/MM/DD HH:mm")}`,
        config,
      );
      if (response.data.length !== 0) turnos = response.data;

      turnosDisponibles = ordenarArrayObjetosByDate(turnos, "fecha");

      prestadores.forEach((prestador) => {
        const horariosPrestador = horariosPrestadoresDisponibles.filter(
          (horario) => Number(horario.prestador) === Number(prestador.codigo),
        );
        const sinFranjasWeb = !prestadorTieneFranjaWeb(horariosPrestador);
        let proximoTurno = turnosDisponibles.find(
          (turno) => Number(turno.prestador) === Number(prestador.codigo),
        );
        if (proximoTurno || sinFranjasWeb) {
          prestadoresFormateados.push({
            ...prestador,
            sinFranjasWeb,
            note: proximoTurno?.fecha,
          });
        }
      });
    } catch (error) {
      throw new Error("Error al obtener los turnos futuros: " + error.message);
    }
    return prestadoresFormateados;
  };

  const traerHorariosPrestadores = async (paciente) => {
    let horarios = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(`${url}PrestadoresHorarios`, config);

      if (response.data.length !== 0) {
        horarios = response.data;
      }

      setHorariosPrestadores(horarios);
      setHorariosPrestadoresCargados(true);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al consultar los horarios de los prestadores",
        "rojo",
      );
    }

    return horarios;
  };

  const traerNotaWebMutualPaciente = async (paciente) => {
    const url = localStorage.getItem("urlAxioPP");

    try {
      const notaWeb = await obtenerNotaWebMutual(
        url,
        paciente.token,
        paciente.mutual,
      );
      setNotaWebMutual(notaWeb);
    } catch (e) {
      setNotaWebMutual("");
    }
  };

  const traerPrestadores = async (
    paciente,
    modalidadFiltro,
    horariosPrestadoresDisponibles,
  ) => {
    let prestadores = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(
        `${url}Prestadores?mutuales=${paciente.mutual}`,
        config,
      );

      if (response.data.length !== 0) {
        prestadores = response.data;
      }

      prestadores = prestadores.filter(
        (prestador) => prestador.vigente === true,
      );

      let edad = dayjs(dayjs()).diff(paciente.nacimiento, "year");

      prestadores = prestadores.filter((prestador) => {
        if (prestador.filtroEdad) {
          if (prestador.edadDesde <= edad && edad <= prestador.edadHasta)
            return prestador;
        } else {
          return prestador;
        }
      });

      if (edad <= 15) {
        prestadores = prestadores.filter((prestador) =>
          [125, 115].includes(prestador.especialidad),
        );
      } else {
        prestadores = prestadores.filter(
          (prestador) => ![125, 115].includes(prestador.especialidad),
        );
      }

      prestadores = await obtenerPrimerosProximosTurnos(
        paciente,
        prestadores,
        horariosPrestadoresDisponibles,
      );

      const cacheAgendaModalidad = new Map();
      const validarAgendaModalidadPrestador = async (prestadorCodigo) => {
        const clave = Number(prestadorCodigo);
        if (cacheAgendaModalidad.has(clave)) {
          return cacheAgendaModalidad.get(clave);
        }

        const tieneAgendaModalidad = await prestadorTieneAgendaModalidad(
          url,
          config,
          prestadorCodigo,
          modalidadFiltro,
        );
        cacheAgendaModalidad.set(clave, tieneAgendaModalidad);
        return tieneAgendaModalidad;
      };

      let prestadoresExcluidosPorHorario = [];
      if (modalidadFiltro !== null) {
        const prestadoresEvaluados = prestadores.map((prestador) => {
          const horariosPrestador = horariosPrestadoresDisponibles.filter(
            (horario) => Number(horario.prestador) === Number(prestador.codigo),
          );

          const disponiblePorModalidad = prestadorTieneModalidadDisponible(
            horariosPrestador,
            modalidadFiltro,
          );
          const sinFranjasWeb = !prestadorTieneFranjaWeb(horariosPrestador);

          return {
            ...prestador,
            sinFranjasWeb,
            disponiblePorModalidad: sinFranjasWeb || disponiblePorModalidad,
          };
        });

        prestadores = prestadoresEvaluados.filter(
          (prestador) => prestador.disponiblePorModalidad,
        );
        prestadoresExcluidosPorHorario = prestadoresEvaluados.filter(
          (prestador) => !prestador.disponiblePorModalidad,
        );
      }

      if (
        modalidadFiltro !== null &&
        prestadoresExcluidosPorHorario.length > 0
      ) {
        const prestadoresRecuperadosPorAgenda = await Promise.all(
          prestadoresExcluidosPorHorario.map(async (prestador) => {
            const tieneAgendaModalidad = await validarAgendaModalidadPrestador(
              prestador.codigo,
            );
            return tieneAgendaModalidad ? prestador : null;
          }),
        );

        const prestadoresPorCodigo = new Map();

        [
          ...prestadores,
          ...prestadoresRecuperadosPorAgenda.filter(Boolean),
        ].forEach((prestador) => {
          prestadoresPorCodigo.set(Number(prestador.codigo), prestador);
        });

        prestadores = Array.from(prestadoresPorCodigo.values());
      }

      if (modalidadFiltro !== null && prestadores.length > 0) {
        const prestadoresConAgendaModalidad = await Promise.all(
          prestadores.map(async (prestador) => {
            if (prestador.sinFranjasWeb) {
              return prestador;
            }

            const tieneAgendaModalidad = await validarAgendaModalidadPrestador(
              prestador.codigo,
            );
            return tieneAgendaModalidad ? prestador : null;
          }),
        );

        prestadores = prestadoresConAgendaModalidad.filter(Boolean);
      }

      prestadores = prestadores.map((prestador) => {
        return {
          ...prestador,
          text: prestador.nombre,
          imageSrc: obtenerFotoPrestador(prestador),
          fechaProximoTurno: prestador.note,
          note: prestador.sinFranjasWeb
            ? "Turnos por Whatsapp"
            : `Proximo turno: ${obtenerNombreDia(
                dayjs(prestador.note).format("dddd"),
              )} ${dayjs(prestador.note).format("DD")} de ${dayjs(
                prestador.note,
              ).format("MMMM, YYYY")}`,
        };
      });

    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al consultar los prestadores registrados en el sistema",
        "rojo",
      );
      return [];
    }
    return prestadores;
  };

  const traerEspecialidades = async (paciente, prestadoresDisponibles) => {
    let especialidades = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(`${url}Especialidades`, config);
      if (response.data.length !== 0) {
        especialidades = response.data;
      } else {
        especialidades = null;
      }
      especialidades = especialidades.filter(
        (especialidad) => especialidad.vigente === true,
      );

      const especialidadesMostrables = new Set();
      prestadoresDisponibles.forEach((prestador) => {
        [
          prestador.especialidad,
          prestador.especialidad2,
          prestador.especialidad3,
        ]
          .filter((valor) => valor !== null && valor !== undefined && valor > 0)
          .forEach((valor) => especialidadesMostrables.add(valor));
      });

      const especialidadesCoincidentes = [];
      especialidades.forEach((especialidad) => {
        if (especialidadesMostrables.has(especialidad.codigo)) {
          especialidadesCoincidentes.push(especialidad);
        }
      });
      especialidades = especialidadesCoincidentes;
      especialidades = especialidades.map((especialidad) => {
        return {
          ...especialidad,
          text: especialidad.nombre,
        };
      });

      return especialidades;
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al consultar las especialidades registradas en el sistema",
        "rojo",
      );
      return [];
    }
  };

  const traerTurnosPaciente = async (paciente) => {
    let turnos = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const servicio = await axios
        .get(`${url}Servicios`, config)
        .then((response) => {
          if (response.data.length !== 0) {
            return response.data;
          } else {
            return null;
          }
        });
      if (servicio !== null) {
        const response = await axios.get(
          `${url}Turnos/TurnosPaciente/?paciente=${paciente.codigo}&servicio=${servicio[0].codigo}`,
          config,
        );
        if (response.data.length !== 0) {
          turnos = response.data;
          turnos = turnos.sort((a, b) => {
            const fechaA = dayjs(a.fecha);
            const fechaB = dayjs(b.fecha);

            if (fechaA.isBefore(fechaB)) {
              return -1;
            } else if (fechaA.isAfter(fechaB)) {
              return 1;
            } else {
              const horaA = dayjs(a.hora, "HH:mm:ss");
              const horaB = dayjs(b.hora, "HH:mm:ss");

              if (horaA.isBefore(horaB)) {
                return -1;
              } else if (horaA.isAfter(horaB)) {
                return 1;
              } else {
                return 0;
              }
            }
          });
          turnos = turnos.slice(0, 5);
        } else {
          turnos = [];
        }

        setTurnosPaciente(turnos);
      }
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar sus proximos turnos",
        "rojo",
      );
    }
  };

  const cargarDesplegables = async (
    sesion,
    modalidadFiltro,
    horariosPrestadoresDisponibles,
  ) => {
    const requestId = iniciarCargaDesplegables();
    limpiarEstadoReserva({ limpiarCatalogos: true });

    try {
      const prestadoresDisponibles = await traerPrestadores(
        sesion,
        modalidadFiltro,
        horariosPrestadoresDisponibles,
      );
      if (!esCargaDesplegablesVigente(requestId)) {
        return;
      }

      const especialidadesDisponibles = await traerEspecialidades(
        sesion,
        prestadoresDisponibles,
      );
      if (!esCargaDesplegablesVigente(requestId)) {
        return;
      }

      setPrestadores(prestadoresDisponibles);
      setListadoPrestadores(prestadoresDisponibles);
      setEspecialidades(especialidadesDisponibles || []);
    } finally {
      finalizarCargaDesplegables(requestId);
    }
  };

  useEffect(() => {
    const inicializarDatos = async () => {
      setCargando(true);
      try {
        const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
        if (sesion) {
          await Promise.all([
            traerTurnosPaciente(sesion),
            traerHorariosPrestadores(sesion),
            traerNotaWebMutualPaciente(sesion),
          ]);

          setUsuario(sesion);
          setUrlAxio(localStorage.getItem("urlAxioPP"));
          setTituloPagina(localStorage.getItem("nombreClinica"));
          document.title = localStorage.getItem("tituloWeb");

          const prestadorInicial = history.location.state?.prestador;
          if (prestadorInicial !== undefined && prestadorInicial !== null) {
            setPrestadorPreseleccionado(normalizarCodigo(prestadorInicial));
            setPrestadorSeleccionadoExternamente(true);
          }
        }
      } catch (e) {
        history.push({ pathname: "/ErrorPage" });
      } finally {
        setCargando(false);
      }
    };

    inicializarDatos();
  }, []);

  useEffect(() => {
    const cargarDatos = async () => {
      if (
        horariosPrestadoresCargados &&
        usuario.codigo &&
        modalidadSeleccionada !== null
      ) {
        await cargarDesplegables(
          usuario,
          modalidadSeleccionada,
          horariosPrestadores,
        );
      }
    };

    cargarDatos();
  }, [
    horariosPrestadores,
    horariosPrestadoresCargados,
    usuario,
    modalidadSeleccionada,
  ]);

  useEffect(() => {
    if (
      modalidadSeleccionada !== null &&
      !abrirDesplegableEspecialidades &&
      especialidadSeleccionada !== -1 &&
      !prestadorSeleccionadoExternamente &&
      prestadorSeleccionado === -1 &&
      fechasFuturas.length === 0
    ) {
      setAbrirDesplegablePrestadores(true);
    }
  }, [
    modalidadSeleccionada,
    abrirDesplegableEspecialidades,
    especialidadSeleccionada,
    prestadorSeleccionadoExternamente,
    prestadorSeleccionado,
    fechasFuturas,
  ]);

  useEffect(() => {
    if (
      modalidadSeleccionada !== null &&
      especialidades.length > 0 &&
      especialidadSeleccionada === -1 &&
      !cargando &&
      !prestadorSeleccionadoExternamente
    ) {
      setAbrirDesplegableEspecialidades(true);
    }
  }, [
    modalidadSeleccionada,
    especialidades,
    especialidadSeleccionada,
    cargando,
    prestadorSeleccionadoExternamente,
  ]);

  useEffect(() => {
    return () => {
      cargaDesplegablesRef.current += 1;
    };
  }, []);

  useEffect(() => {
    const manejarPrestadorPreseleccionado = async () => {
      if (
        modalidadSeleccionada !== null &&
        especialidades.length > 0 &&
        prestadores.length > 0 &&
        prestadorSeleccionado === -1 &&
        prestadorPreseleccionado !== undefined &&
        prestadorPreseleccionado !== null &&
        !cargando
      ) {
        const prestadorCodigo = normalizarCodigo(prestadorPreseleccionado);

        const prestadorEncontrado = prestadores.find(
          (prestador) =>
            normalizarCodigo(prestador.codigo) === prestadorCodigo,
        );

        if (prestadorEncontrado) {
          const especialidadPrestador = normalizarCodigo(
            prestadorEncontrado.especialidad,
          );
          setEspecialidadSeleccionada(especialidadPrestador);

          const prestadoresFiltrados = prestadores.filter(
            (prestador) =>
              normalizarCodigo(prestador.especialidad) ===
                especialidadPrestador ||
              normalizarCodigo(prestador.especialidad2) ===
                especialidadPrestador,
          );

          const prestadoresOrdenados =
            ordenarPrestadoresPorProximoTurno(prestadoresFiltrados);
          setListadoPrestadores(prestadoresOrdenados);

          setPrestadorSeleccionado(prestadorCodigo);

          setAbrirDesplegableEspecialidades(false);
          setAbrirDesplegablePrestadores(false);

          const inasistencias = verificarInasistenciasPorEspecialidad(
            especialidadPrestador,
          );

          if (inasistencias <= 1) {
            const turnoPendiente =
              verificarTurnoConPrestadorPendiente(prestadorCodigo);

            if (!turnoPendiente) {
              mostrarNotificacion(
                true,
                `Cargando horarios disponibles para ${prestadorEncontrado.nombre}...`,
                "verde",
              );
              await traerHorariosAtencion(prestadorCodigo);
            } else {
            }
          } else {
          }
        } else {
          mostrarNotificacion(
            true,
            "El prestador seleccionado no está disponible, seleccione una especialidad",
            "amarillo",
          );
          setAbrirDesplegableEspecialidades(true);
        }

        setPrestadorPreseleccionado(null);
        setPrestadorSeleccionadoExternamente(false);
      }
    };

    if (prestadorSeleccionadoExternamente) {
      manejarPrestadorPreseleccionado();
    }
  }, [
    prestadores,
    especialidades,
    history,
    modalidadSeleccionada,
    prestadorSeleccionado,
    cargando,
    prestadorSeleccionadoExternamente,
    prestadorPreseleccionado,
  ]);

  const obtenerTurnos = async (config, prestador) => {
    let turnos = [];
    try {
      const response = await axios.get(
        `${urlAxioPP}Turnos/TurnosPrestadorFecha/?prestador=${prestador}&desde=${dayjs().format(
          "YYYY/MM/DD hh:mm",
        )}&hasta=${dayjs().add(3, "month").format("YYYY/MM/DD hh:mm")}`,
        config,
      );
      if (response.data.length !== 0) turnos = response.data;

      const turnosDisponibles = [];
      const turnosDadosMutual = [];

      turnos.forEach((turno) => {
        const turnoNormalizado = normalizarModalidadesTurno(turno);
        const diaSemana = dayjs(turno.fecha).get("d");
        const dia = diasSemana[diaSemana];
        let semanaTurno = dayjs(turno.fecha).week();
        let turnosPorSemana = {
          domingo: 0,
          lunes: 0,
          martes: 0,
          miercoles: 0,
          jueves: 0,
          viernes: 0,
          sabado: 0,
        };

        // Permitimos entreTurno cuando el slot es de telemedicina
        const esVirtual = turnoNormalizado.permiteVirtual;
        if (
          turnoNormalizado.libre &&
          !turnoNormalizado.cancelado &&
          !turnoNormalizado.reservado &&
          (esVirtual || !turno.entreTurno)
        ) {
          turnosDisponibles.push(turnoNormalizado);
        }

        let turnosSemana = turnosDadosMutual.find(
          (turno) => turno.semana === semanaTurno,
        );
        if (!turnosSemana) {
          turnosPorSemana[dia] += 1;
          turnosDadosMutual.push({
            semana: semanaTurno,
            ...turnosPorSemana,
            totalTurnosAsignadosMutual: 1,
          });
        } else {
          if (turnoNormalizado.mutual === usuario.mutual) {
            turnosSemana = {
              ...turnosSemana,
              [dia]: turnosSemana[dia] + 1,
              totalTurnosAsignadosMutual:
                turnosSemana.totalTurnosAsignadosMutual + 1,
            };
            turnosDadosMutual[
              turnosDadosMutual.findIndex(
                (turno) => turno.semana === semanaTurno,
              )
            ] = turnosSemana;
          }
        }
      });

      return { turnosDadosMutual, turnosDisponibles };
    } catch (error) {
      throw new Error(
        "Error al obtener los turnos disponibles: " + error.message,
      );
    }
  };

  const filtrarTurnosPorFechaYHora = (turnos) => {
    return turnos.filter(
      (turno) =>
        dayjs(turno.fecha).isSame(dayjs()) ||
        (dayjs(turno.fecha).isAfter(dayjs()) &&
          (dayjs().format("YYYY-MM-DD") !==
            dayjs(turno.fecha).format("YYYY-MM-DD") ||
            (dayjs().format("YYYY-MM-DD") ===
              dayjs(turno.fecha).format("YYYY-MM-DD") &&
              dayjs(turno.hora).format("HH:mm") >
                dayjs().add(3, "hour").format("HH:mm")))),
    );
  };

  const filtrarTurnosPorRestricciones = (
    turnos,
    atiende,
    turnosDadosMutual,
  ) => {
    return turnos.filter((turno) => {
      if (atiende.length === 0) {
        return true;
      } else {
        const diaSemana = dayjs(turno.fecha).get("d");
        const cantidadTurnosDia =
          atiende[0][diasSemana[diaSemana].toLowerCase()];
        const turnosOcupadosDia = turnosDadosMutual.find(
          (turnoMutual) => turnoMutual.semana === dayjs(turno.fecha).week(),
        )[diasSemana[diaSemana].toLowerCase()];
        return turnosOcupadosDia < cantidadTurnosDia;
      }
    });
  };

  const obtenerFechasTurnos = (turnosFiltrados) => {
    const fechasTurnos = borrarObjetosDuplicados(turnosFiltrados, "fecha", true)
      .filter((turno) => turno)
      .map((turno) => ({
        fecha: turno,
      }));
    return fechasTurnos;
  };

  const obtenerProximosTurnos = (
    fechasTurnos,
    horarios,
    turnosFiltradosPorRestricciones,
  ) => {
    const turnosProximos = [];
    fechasTurnos.forEach((fecha) => {
      const diaSemana = dayjs(fecha.fecha).get("d");
      const fechaTurno = dayjs(fecha.fecha).format("YYYY-MM-DD");
      const turnosFecha = turnosFiltradosPorRestricciones.filter((turno) =>
        dayjs(turno.fecha).isSame(dayjs(fecha.fecha), "day"),
      );
      const cantTurnos = turnosFecha.length;
      const cantTurnosPresencial = turnosFecha.filter(
        (turno) => turno.permitePresencial,
      ).length;
      const cantTurnosVirtual = turnosFecha.filter(
        (turno) => turno.permiteVirtual,
      ).length;
      if (
        (horarios[diasSemana[diaSemana].toLowerCase() + "MDe"] !== "" &&
          horarios[diasSemana[diaSemana].toLowerCase() + "MHa"]) ||
        (horarios[diasSemana[diaSemana].toLowerCase() + "TDe"] !== "" &&
          horarios[diasSemana[diaSemana].toLowerCase() + "THa"] !== "")
      ) {
        turnosProximos.push({
          date: fechaTurno,
          cantTurnos,
          cantTurnosPresencial,
          cantTurnosVirtual,
          dayVariant: obtenerVarianteDiaAgenda(
            cantTurnosPresencial,
            cantTurnosVirtual,
          ),
        });
      }
    });
    return turnosProximos;
  };

  const traerTurnosAgenda = async (config, prestador, horarios, atiende) => {
    try {
      const { turnosDadosMutual, turnosDisponibles } = await obtenerTurnos(
        config,
        prestador,
      );

      const turnosFiltradosPorFechaYHora =
        filtrarTurnosPorFechaYHora(turnosDisponibles);

      const turnosFiltradosPorRestricciones = filtrarTurnosPorRestricciones(
        turnosFiltradosPorFechaYHora,
        atiende,
        turnosDadosMutual,
      );

      const fechasTurnos = obtenerFechasTurnos(turnosFiltradosPorRestricciones);

      const turnosProximos = obtenerProximosTurnos(
        fechasTurnos,
        horarios,
        turnosFiltradosPorRestricciones,
      );
      if (turnosProximos.length !== 0) {
        const fechasOrdenadas = ordenarArrayObjetosByDate(
          turnosProximos,
          "date",
        );
        const primerDiaConModalidadSeleccionada = fechasOrdenadas.find(
          (fecha) =>
            modalidadSeleccionada === "virtual"
              ? fecha.cantTurnosVirtual > 0
              : fecha.cantTurnosPresencial > 0,
        );

        setFechasFuturas(fechasOrdenadas);
        setFechaSeleccionada(
          (primerDiaConModalidadSeleccionada || fechasOrdenadas[0]).date,
        );
        setTurnosDisponibles(
          ordenarArrayObjetosByDate(turnosFiltradosPorRestricciones, "hora"),
        );
      } else {
        mostrarNotificacion(
          true,
          "No hay turnos disponibles con el prestador seleccionado",
          "amarillo",
        );
      }
    } catch (error) {
      mostrarNotificacion(true, "Error: " + error.message, "rojo");
    }
  };

  const traerHorariosAtencion = async (prestador) => {
    let horarios = null;
    let atiende = [];

    const prestadorSeleccionadoData = prestadores.find(
      (item) => Number(item.codigo) === Number(prestador),
    );
    if (prestadorSeleccionadoData?.sinFranjasWeb) {
      setFechasFuturas([]);
      setFechaSeleccionada("");
      setTurnosDisponibles([]);
      return;
    }

    const config = {
      headers: { Authorization: `Bearer ${usuario.token}` },
    };

    const servicio = await axios
      .get(`${urlAxioPP}Servicios`, config)
      .then((response) => {
        if (response.data.length !== 0) {
          return response.data[0];
        } else {
          return null;
        }
      });

    try {
      const [horariosResponse, atiendeResponse] = await Promise.all([
        axios.get(`${urlAxioPP}PrestadoresHorarios/${prestador}`, config),
        axios.get(
          `${urlAxioPP}Prestadores/RestriccionesPorMutual/${prestador}`,
          config,
        ),
      ]);

      if (
        horariosResponse.data.filter(
          (horario) =>
            normalizarCodigo(horario.prestador) === normalizarCodigo(prestador),
        ).length > 0
      ) {
        horarios = horariosResponse.data.filter(
          (horario) =>
            normalizarCodigo(horario.prestador) === normalizarCodigo(prestador),
        );
      }
      atiende = atiendeResponse.data.filter((a) => a.mutual === usuario.mutual);

      if (!horarios || !horarios[0]?.prestador) {
        mostrarNotificacion(
          true,
          "El prestador seleccionado no tiene un horario definido",
          "rojo",
        );
      } else {
        await traerTurnosAgenda(config, prestador, horarios[0], atiende);
      }
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al intentar consultar los horarios disponibles del prestador",
        "rojo",
      );
    }
  };

  const actualizarTurno = async () => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${usuario.token}` },
      };

      if (turnoSeleccionado) {
        const actualizarTurnoResponse = await axios.patch(
          `${urlAxioPP}Turnos/DarTurno/${turnoSeleccionado.codigo}`,
          {
            codigo: turnoSeleccionado.codigo,
            paciente: usuario.codigo,
            mutual: usuario.mutual,
            // estudio: 0,
            prestador: prestadorSeleccionado,
            telemedicina: turnoSeleccionado.telemedicina,
            observaciones: "Turno reservado via web por el paciente",
          },
          config,
        );
        if (actualizarTurnoResponse.status === 200) {
          mostrarNotificacion(
            true,
            "El turno se reservó correctamente",
            "verde",
          );

          togleAbrirCerrarConfirmarReserva(true);
          setFechaSeleccionada("");
          setTurnosDisponibles([]);
          setAbrirModalPostReserva(true);
        } else {
          mostrarNotificacion(
            true,
            "Ocurrió un problema al intentar reservar el turno",
            "rojo",
          );
        }
      }
    } catch ({ response }) {
      mostrarNotificacion(true, "Error: " + response.data, "rojo");
    }
  };

  const verificarInasistenciasPorEspecialidad = (especialidad) => {
    const turnosPasados = turnosPaciente;
    let inasistidos = 0;

    turnosPasados.forEach((turno) => {
      if (
        (dayjs(turno.fecha).isSame(new dayjs()) &&
          dayjs(turno.hora).format("HH:mm") >=
            dayjs("0001-01-01T00:00:00").format("HH:mm")) ||
        (dayjs(turno.fecha).isAfter(new dayjs().subtract(2, "month")) &&
          dayjs(turno.fecha).isBefore(new dayjs()))
      ) {
        if (turno.especialidad === especialidad && turno.asistio === false) {
          inasistidos += 1;
        }
      }
    });

    return inasistidos;
  };

  const verificarTurnoConPrestadorPendiente = (prestador) => {
    const turnosFuturos = turnosPaciente;
    let turnoPendiente = false;

    turnosFuturos.forEach((turno) => {
      if (
        (dayjs(turno.fecha).isSame(new dayjs()) &&
          dayjs(turno.hora).format("HH:mm") <=
            dayjs("0001-01-01T00:00:00").format("HH:mm")) ||
        (dayjs(turno.fecha).isBefore(new dayjs().add(2, "month")) &&
          dayjs(turno.fecha).isAfter(new dayjs()))
      ) {
        if (turno.prestadorCod === prestador) {
          turnoPendiente = true;
        }
      }
    });

    return turnoPendiente;
  };

  const VerificarInasistenciasPorEspecialidad = (especialidad) => {
    const inasistidos = verificarInasistenciasPorEspecialidad(especialidad);

    setMostrarTurnoPrestadorReservado(false);
    if (inasistidos > 1) {
      setFechasFuturas([]);
      setMostrarInasisEspecilidad(true);
    } else {
      setMostrarInasisEspecilidad(false);
    }
  };

  const VerificarTurnoConPrestadorPendiente = async (prestador) => {
    const turnoPendiente = verificarTurnoConPrestadorPendiente(prestador);

    if (turnoPendiente) {
      setFechasFuturas([]);
      setMostrarTurnoPrestadorReservado(true);
    } else {
      setMostrarTurnoPrestadorReservado(false);
      await traerHorariosAtencion(prestador);
    }
  };

  const ordenarPrestadoresPorProximoTurno = (prestadores) => {
    return prestadores.sort((a, b) => {
      const fechaA = dayjs(a.fechaProximoTurno);
      const fechaB = dayjs(b.fechaProximoTurno);

      if (fechaA.isBefore(fechaB)) {
        return -1;
      } else if (fechaA.isAfter(fechaB)) {
        return 1;
      } else {
        return a.nombre.localeCompare(b.nombre);
      }
    });
  };

  const handleChangeSelect = async (value, select) => {
    setCargando(true);
    try {
      switch (select) {
        case "Especialidad":
          setEspecialidadSeleccionada(value);
          if (value !== -1) {
            const prestadoresFiltrados = prestadores.filter(
              (prestador) =>
                normalizarCodigo(prestador.especialidad) ===
                  normalizarCodigo(value) ||
                normalizarCodigo(prestador.especialidad2) ===
                  normalizarCodigo(value),
            );
            const prestadoresOrdenados =
              ordenarPrestadoresPorProximoTurno(prestadoresFiltrados);
            setListadoPrestadores(prestadoresOrdenados);
            setAbrirDesplegablePrestadores(true);
          } else {
            setListadoPrestadores(prestadores);
          }
          setPrestadorSeleccionado(-1);
          setFechasFuturas([]);
          VerificarInasistenciasPorEspecialidad(value);
          break;
        case "Profesional":
          setPrestadorSeleccionado(value);
          await VerificarTurnoConPrestadorPendiente(value);
          break;
        default:
          mostrarNotificacion(true, "Seleccion invalida", "rojo");
          break;
      }
    } finally {
      setCargando(false);
    }
  };

  const handleChangeFecha = (value) => {
    setFechaSeleccionada(value);
  };

  const togleAbrirCerrarConfirmarReserva = (confirma = false) => {
    if (abrirModalConfirmarReserva && !confirma) {
      setTurnoSeleccionado({});
    }
    setAbrirModalConfirmarReserva(!abrirModalConfirmarReserva);
  };

  const handleClickSeleccionarTurno = (turno) => {
    const modalidadReserva = modalidadSeleccionada;
    const turnoNormalizado = {
      ...turno,
      telemedicina: modalidadReserva === "virtual",
    };

    setTurnoSeleccionado(turnoNormalizado);

    setAbrirModalSelectorModalidad(false);
    togleAbrirCerrarConfirmarReserva();
  };

  const handleClickConfirmarHacerReserva = async () => {
    setCargando(true);
    await actualizarTurno();
    setCargando(false);
  };

  const handleSeleccionarModalidadPresencial = () => {
    // Actualizar el turno seleccionado con modalidad presencial
    setTurnoSeleccionado({
      ...turnoSeleccionado,
      telemedicina: false,
    });
    setAbrirModalSelectorModalidad(false);
    togleAbrirCerrarConfirmarReserva();
  };

  const handleSeleccionarModalidadVirtual = () => {
    // Actualizar el turno seleccionado con modalidad virtual
    setTurnoSeleccionado({
      ...turnoSeleccionado,
      telemedicina: true,
    });
    setAbrirModalSelectorModalidad(false);
    togleAbrirCerrarConfirmarReserva();
  };

  const handleClickCopiarTelefono = () => {
    const phoneNumber = "08105552765";
    navigator.clipboard.writeText(phoneNumber);

    mostrarNotificacion(
      true,
      "Se ha copiado el numero de telefono a su portapapeles",
      "",
    );
  };

  const handlePostTurnoReservado = (accion) => {
    setTurnoSeleccionado({});
    setAbrirModalPostReserva(false);
    switch (accion) {
      case "nuevoTurno":
        window.location.reload();
        break;
      case "turnosPaciente":
        history.push({ pathname: "/portal/Turnos" });
        break;
      default:
        history.push({ pathname: "/portal/Turnos" });
        break;
    }
  };

  const renderBloqueTurnos = (titulo, turnos, modalidadBloque) => {
    if (turnos.length === 0) {
      return null;
    }

    return (
      <IonList
        className={`nuevo-turno-agenda-lista nuevo-turno-agenda-lista-${modalidadBloque}`}
      >
        <IonListHeader>
          <Typography level="body-md">
            {titulo} ({turnos.length})
          </Typography>
        </IonListHeader>
        <IonGrid>
          <IonRow>
            {turnos.map((turno) => (
              <Column
                container
                xs={6}
                md={3}
                key={`${turno.codigo}-${modalidadBloque}`}
              >
                <StyledButton
                  expand="block"
                  className="blanco nuevo-turno-agenda-btn"
                  onClick={() => handleClickSeleccionarTurno(turno)}
                >
                  {dayjs(turno.hora).format("HH:mm")}
                </StyledButton>
              </Column>
            ))}
          </IonRow>
        </IonGrid>
      </IonList>
    );
  };

  const renderTurnos = () => {
    const turnos = turnosDisponibles.filter(
      (turno) =>
        dayjs(turno.fecha).format("YYYY-MM-DD") ===
        dayjs(fechaSeleccionada).format("YYYY-MM-DD"),
    );
    const turnosModalidadSeleccionada = turnos.filter((turno) =>
      tieneTurnoVisiblePorModalidad(turno, modalidadSeleccionada),
    );
    const bloquesTurnos = [
      renderBloqueTurnos(
        modalidadSeleccionada === "virtual"
          ? "Horarios Virtuales disponibles"
          : "Horarios Presenciales disponibles",
        turnosModalidadSeleccionada,
        modalidadSeleccionada === "virtual" ? "virtual" : "presencial",
      ),
    ];

    return (
      turnosModalidadSeleccionada.length !== 0 && (
        <IonCol>
          <IonList lines="none" className="nuevo-turno-agenda-wrapper">
            <IonListHeader>
              <Typography level="body-md">
                {`${obtenerNombreDia(
                  dayjs(fechaSeleccionada).format("dddd"),
                )} ${dayjs(fechaSeleccionada).format("DD")} de ${dayjs(
                  fechaSeleccionada,
                ).format("MMMM, YYYY")}`}
              </Typography>
            </IonListHeader>
            {bloquesTurnos}
          </IonList>
        </IonCol>
      )
    );
  };

  return (
    <>
      <div slot="content">
        {prestadorSeleccionadoExternamente &&
          prestadorSeleccionado !== -1 &&
          fechasFuturas.length === 0 &&
          !mostrarInasisEspecilidad &&
          !mostrarTurnoPrestadorReservado && (
            <Container>
              <Row
                container
                width="100%"
                style={{ justifyContent: "center", marginBottom: "20px" }}
              >
                <Column xs={12}>
                  <Typography
                    level="body-lg"
                    style={{
                      textAlign: "center",
                      color: "#dec020",
                      fontWeight: "bold",
                    }}
                  >
                    Cargando horarios disponibles para el prestador
                    seleccionado...
                  </Typography>
                </Column>
              </Row>
            </Container>
          )}

        <Container>
          <Row container width="100%">
            {modalidadSeleccionada === null && (
              <Column xs={12}>
                <IonCard className="nuevo-turno-modalidad-card">
                  <IonCardContent>
                    <Typography level="title-md">
                      Seleccione la modalidad de atención
                    </Typography>
                    <Typography
                      level="body-sm"
                      className="nuevo-turno-modalidad-text"
                    >
                      Elija si desea reservar un turno presencial o virtual para
                      continuar con la búsqueda por especialidad y profesional.
                    </Typography>
                    <Row
                      container
                      spacing={2}
                      className="nuevo-turno-modalidad-actions"
                    >
                      <Column xs={12} md={6}>
                        <StyledButton
                          expand="block"
                          className="blanco nuevo-turno-modalidad-btn"
                          onClick={() => setModalidadSeleccionada("presencial")}
                        >
                          Presencial
                        </StyledButton>
                      </Column>
                      <Column xs={12} md={6}>
                        <StyledButton
                          expand="block"
                          className="blanco nuevo-turno-modalidad-btn"
                          onClick={() => setModalidadSeleccionada("virtual")}
                        >
                          Virtual
                        </StyledButton>
                      </Column>
                    </Row>
                  </IonCardContent>
                </IonCard>
              </Column>
            )}
            {!cargando &&
              modalidadSeleccionada !== null &&
              prestadores.length === 0 && (
                <Column xs={12}>
                  <IonCard className="nuevo-turno-modalidad-card">
                    <IonCardContent>
                      <Typography level="body-md">
                        No hay profesionales con turnos{" "}
                        {obtenerLabelModalidad(
                          modalidadSeleccionada,
                        ).toLowerCase()}{" "}
                        disponibles en este momento.
                      </Typography>
                    </IonCardContent>
                  </IonCard>
                </Column>
              )}
            {!cargando &&
              modalidadSeleccionada !== null &&
              prestadores.length > 0 &&
              especialidades.length === 0 && (
                <Column xs={12}>
                  <IonCard className="nuevo-turno-modalidad-card">
                    <IonCardContent>
                      <Typography level="body-md">
                        No hay especialidades disponibles para la modalidad{" "}
                        {obtenerLabelModalidad(
                          modalidadSeleccionada,
                        ).toLowerCase()}{" "}
                        en este momento.
                      </Typography>
                    </IonCardContent>
                  </IonCard>
                </Column>
              )}
            {!cargando &&
              modalidadSeleccionada !== null &&
              especialidades.length > 0 &&
              !(
                prestadorSeleccionadoExternamente &&
                prestadorSeleccionado !== -1 &&
                !mostrarInasisEspecilidad &&
                !mostrarTurnoPrestadorReservado
              ) && (
                <Column xs={12} md={6}>
                  <IonItem className="amarillo-sol">
                    <CustomDesplegable
                      array={especialidades}
                      value={especialidadSeleccionada}
                      handleChange={handleChangeSelect}
                      mostrarTodos={false}
                      mostrarSearch={true}
                      placeholder={`Seleccione una especialidad ${obtenerLabelModalidad(
                        modalidadSeleccionada,
                      ).toLowerCase()}...`}
                      label="Especialidades"
                      id="Especialidad"
                      isOpen={abrirDesplegableEspecialidades}
                      setIsOpen={setAbrirDesplegableEspecialidades}
                      variant="plain"
                    />
                  </IonItem>
                </Column>
              )}
            {modalidadSeleccionada !== null &&
              especialidadSeleccionada !== -1 &&
              !(
                prestadorSeleccionadoExternamente &&
                prestadorSeleccionado !== -1 &&
                !mostrarInasisEspecilidad &&
                !mostrarTurnoPrestadorReservado
              ) && (
                <Column xs={12} md={6}>
                  <IonItem className="amarillo-sol">
                    <CustomDesplegable
                      array={listadoPrestadores}
                      value={prestadorSeleccionado}
                      handleChange={handleChangeSelect}
                      mostrarTodos={false}
                      mostrarSearch={true}
                      placeholder={`Seleccione un profesional ${obtenerLabelModalidad(
                        modalidadSeleccionada,
                      ).toLowerCase()}...`}
                      label="Profesionales"
                      id="Profesional"
                      isOpen={abrirDesplegablePrestadores}
                      setIsOpen={setAbrirDesplegablePrestadores}
                      variant="plain"
                    />
                  </IonItem>
                </Column>
              )}
          </Row>
        </Container>

        {prestadorActual?.imageSrc &&
          !mostrarInasisEspecilidad &&
          !mostrarTurnoPrestadorReservado && (
            <Container className="reserva-prestador-foto-wrapper">
              <Row container width="100%">
                <Column xs={12} md={6}>
                  <div className="reserva-prestador-foto-card">
                    <div className="reserva-prestador-foto-frame">
                      <img
                        src={prestadorActual.imageSrc}
                        alt={prestadorActual.nombre}
                        className="reserva-prestador-foto"
                      />
                    </div>
                    <div className="reserva-prestador-foto-info">
                      <Typography
                        level="title-sm"
                        className="reserva-prestador-foto-nombre"
                      >
                        {prestadorActual.nombre}
                      </Typography>
                      <Typography
                        level="body-sm"
                        className="reserva-prestador-foto-detalle"
                      >
                        {obtenerNombreEspecialidadPrestador(prestadorActual)}
                      </Typography>
                    </div>
                  </div>
                </Column>
              </Row>
            </Container>
          )}

        {mostrarNotaWebMutual && (
          <IonGrid className="nuevo-turno-nota-mutual-grid">
            <IonRow>
              <IonCol size="12">
                <IonCard className="nuevo-turno-nota-mutual-card">
                  <IonCardContent>
                    <Typography
                      level="title-sm"
                      className="nuevo-turno-nota-mutual-titulo"
                    >
                      Información de su mutual
                    </Typography>
                    <Typography
                      level="body-sm"
                      className="nuevo-turno-nota-mutual-texto"
                    >
                      {notaWebMutual}
                    </Typography>
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        )}

        {mostrarTurnosWhatsapp && (
          <IonGrid className="nuevo-turno-nota-mutual-grid">
            <IonRow>
              <IonCol size="12">
                <IonCard className="nuevo-turno-nota-mutual-card">
                  <IonCardContent>
                    <Typography
                      level="title-sm"
                      className="nuevo-turno-nota-mutual-titulo"
                    >
                      Turnos por Whatsapp
                    </Typography>
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        )}

        {fechasFuturas.length > 0 && (
          <IonGrid>
            <IonRow>
              <IonCol>
                <CustomCalendar
                  onChange={(newSelectedDate) =>
                    handleChangeFecha(
                      dayjs(newSelectedDate).format("YYYY-MM-DD"),
                    )
                  }
                  minDate={dayjs(new dayjs())}
                  maxDate={dayjs(new dayjs()).add(3, "months")}
                  value={fechaSeleccionada}
                  highlightedDates={fechasFuturas}
                />
              </IonCol>
              {turnosDisponibles.length > 0 && renderTurnos()}
            </IonRow>
          </IonGrid>
        )}
      </div>

      {mostrarInasisEspecilidad && (
        <IonRow className="ion-justify-content-center">
          <IonCol>
            <IonCard color="warning">
              <IonCardContent>
                <h4 className="main-content">
                  ⚠ No podes reservar un nuevo turno con esta especialidad
                  debido a que no asististe a 2 o mas turnos en los ultimos 2
                  meses para la especialidad que seleccionaste. Estaremos
                  encantados de atenderte y brindarte la mejor atención
                  personalizada si te pones en contacto. Podes presionar los
                  botones inferiores para copiar el numero de telefono fijo o
                  llevarte a nuestro chat de Whatsapp.
                </h4>
              </IonCardContent>
              <IonRow>
                <IonCol>
                  <StyledButton
                    className="verde"
                    expand="block"
                    // href="https://api.whatsapp.com/send?phone=5493513455853&text=Hola%2C%20me%20ponía%20en%20contacto%20para%20poder%20sacar%20un%20turno%20para%20tratamientos%20estéticos"
                  >
                    <IonIcon icon={logoWhatsapp} />
                    <IonLabel>WhatsApp</IonLabel>
                  </StyledButton>
                </IonCol>
                <IonCol>
                  <StyledButton
                    className="blanco"
                    expand="block"
                    onClick={handleClickCopiarTelefono}
                  >
                    <IonIcon icon={callSharp} />
                    <IonLabel>Telefono</IonLabel>
                  </StyledButton>
                </IonCol>
              </IonRow>
            </IonCard>
          </IonCol>
        </IonRow>
      )}
      {mostrarTurnoPrestadorReservado && (
        <IonRow className="ion-justify-content-center">
          <IonCol>
            <IonCard color="warning">
              <IonCardContent>
                <h4 className="main-content">
                  ⚠ No esta permitido sacar un segundo turno para un mismo
                  prestador
                </h4>
              </IonCardContent>
            </IonCard>
          </IonCol>
        </IonRow>
      )}

      <DialogoConfirmacion
        titulo="Seleccione modalidad de atención"
        texto="Seleccione si desea su turno con modalidad Presencial o Virtual"
        open={abrirModalSelectorModalidad}
        setOpen={setAbrirModalSelectorModalidad}
        handleClickConfirmar={handleSeleccionarModalidadVirtual}
        handleClickCancelar={handleSeleccionarModalidadPresencial}
        colorBotonNo="primary"
        colorBotonSi="success"
        variantBotonNo="solid"
        variantBotonSi="solid"
        textoBotonNo="Presencial"
        textoBotonSi="Virtual"
      />

      <DialogoConfirmacion
        titulo="Reservar turno"
        texto={
          <>
            Ha seleccionado el turno de{" "}
            <strong>
              {obtenerDescripcionModalidadTurno(turnoSeleccionado.telemedicina)}
            </strong>{" "}
            con el/la profesional {turnoSeleccionado.prestadorNom}, con
            especialidad en {turnoSeleccionado.especialidadNom}, para el día{" "}
            {dayjs(turnoSeleccionado.fecha).format("DD/MM/YYYY")}, a las{" "}
            {dayjs(turnoSeleccionado.hora).format("HH:mm")}, ¿es esto correcto?
          </>
        }
        open={abrirModalConfirmarReserva}
        setOpen={setAbrirModalConfirmarReserva}
        handleClickConfirmar={handleClickConfirmarHacerReserva}
        colorBotonNo="danger"
        colorBotonSi="success"
        textoBotonNo="No, Revisar"
        textoBotonSi="Si, Confirmar"
      />

      <DialogoConfirmacion
        titulo="Turno reservado"
        texto={
          <>
            Se ha reservado exitosamente el turno de{" "}
            <strong>
              {obtenerDescripcionModalidadTurno(turnoSeleccionado.telemedicina)}
            </strong>{" "}
            con el/la profesional {turnoSeleccionado.prestadorNom}, con
            especialidad en {turnoSeleccionado.especialidadNom}, para el día{" "}
            {dayjs(turnoSeleccionado.fecha).format("DD/MM/YYYY")}, a las{" "}
            {dayjs(turnoSeleccionado.hora).format("HH:mm")}
          </>
        }
        open={abrirModalPostReserva}
        setOpen={setAbrirModalPostReserva}
        handleClickConfirmar={() => handlePostTurnoReservado("nuevoTurno")}
        handleClickCancelar={() => handlePostTurnoReservado("turnosPaciente")}
        variantBotonNo="solid"
        colorBotonNo="primary"
        variantBotonSi="solid"
        colorBotonSi="primary"
        variantDialog="plain"
        colorDialogo="success"
        textoBotonNo="Consultar mis turnos"
        textoBotonSi="Reservar nuevo turno"
      />

      <CustomToast
        openToast={toast.open}
        onDidDismiss={(e) => mostrarNotificacion(false, "", "")}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
      />
      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </>
  );
}
